<template>
    <div>
            <form action="">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title has-text-white">Update Item: {{serial}}</p>
                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
                    <section class="modal-card-body has-background-dvodark">
                        <b-field label="Serial #">
                            <b-input
                                type="text"
                                v-model="serial"
                                disabled>
                            </b-input>
                        </b-field>
                    <b-field label="User">
                        <b-select expanded v-model="person_id" placeholder="User">
                            <option class="has-text-white" selected="selected"> {{ person_id }}
                            </option>
                            <option class="has-text-white" v-for="option in users" :value="option.id"
                                :key="option.id">
                                {{ option.email}}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field label="Product Code">
                        <b-select expanded v-model="product_id" placeholder="Product Code">
                            <option class="has-text-white" selected="selected"> {{ product_id }}
                            </option>
                            <option class="has-text-white" v-for="option in products" :value="option.code"
                                :key="option.id">
                                {{ option.description }}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field label="Date of purchase">
                        <b-datepicker
                        placeholder="Select a date..."
                        icon="calendar-today"
                        locale="en-US"
                        v-model="date_of_purchase">
                        </b-datepicker>
                    </b-field>
                    <b-field label="Date of production">
                        <b-datepicker
                        placeholder="Select a date..."
                        icon="calendar-today"
                        locale="en-US"
                        v-model="date_of_production">
                        </b-datepicker>
                    </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <b-button class="is-dvogreen" @click="updateItem()">Update Product</b-button>
                    </footer>
                </div>
            </form>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { itemHandler } from '../graphql/mutations'
import { personReader, getProducts } from '../graphql/queries'
export default {
    data() {
        return {
            users: [],
            products: [],
            request_type: 'update_from_modal',
            serial: this.initSerial,
            person_id: this.initPersonId,
            product_id: this.initProductId,
            date_of_purchase: new Date (this.initDateOfPurchase),
            date_of_production: new Date (this.initDateOfProduction),
        }
    },
    props: ['initSerial', 'initPersonId', 'initProductId', 'initDateOfPurchase', 'initDateOfProduction'],
    methods: {
        async getUsers() {
            const Users = await API.graphql({
                query: personReader,
                variables: {
                    input: {
                        request_type: 'read_all'
                    }
                }
            });
            this.users = Users.data.personReader;
        },
        async getProducts() {
            const Products = await API.graphql({
                query: getProducts
            });
            this.products = Products.data.getProducts;
        },
        async updateItem() {
            const purchased = this.date_of_purchase.getFullYear() + "/" + (this.date_of_purchase.getMonth() + 1) + "/" + this.date_of_purchase.getDate();
            const production = this.date_of_production.getFullYear() + "/" + (this.date_of_production.getMonth() + 1) + "/" + this.date_of_production.getDate();
            const Item = {
                request_type: this.request_type,
                serial: this.serial,
                person_id: this.person_id,
                product_id: this.product_id,
                date_purchase: purchased,
                date_production: production,
            };
            const temp = await API.graphql({
                query: itemHandler,
                variables: {
                    input: Item
                },
            });
            const valToPass = temp.data.itemHandler
            this.$emit('close', valToPass);
        }
    },
    created() {
        this.getUsers();
        this.getProducts();
    }
}
</script>
